module.exports = __webpack_public_path__ + "img/4e4e056.jpg";